import { useState, useEffect } from "react"
import { Grid, Container, Typography } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles"
import { Card, CardHeader, CardActions, CardContent, Snackbar, Box } from "@mui/material"
import LineDashboard from "../dashboard/charts/LineChart/LineDashboard"
import DoughnutDasboard from "../dashboard/charts/DoughnutChart/DoughnutDasboard"
import BateryData from "../dashboard/charts/data/BateryData"
import RemovedData from "../dashboard/charts/data/RemovedData"
import ShotData from "../dashboard/charts/data/ShotData"
import AlarmData from "../dashboard/charts/data/AlarmData"
import DoughnutData from "../dashboard/charts/data/DoughnutData"
import Calendar from "../dashboard/charts/data/Calendar"
import ACOutData from "../dashboard/charts/data/ACOutData"
import { subDays, format } from "date-fns"

const useStyles = makeStyles({
    gridDashboard: {
        // marginBottom: '1rem',
        // width: '100%',
        // maxWidth: '100%',
        marginBottom: '35px'
    }
})

export default function Dashboards(props) {
    const classes = useStyles()
    const [open, setOpen] = useState(false)
    const [refreshDate, setRefreshDate] = useState(format(Date.now(), 'dd-MM-yyyy HH:mm:ss'))
    const [refreshTick, setRefreshTick] = useState(0) // NOVO: contador de atualização

    // Atualiza o refreshTick a cada 5 minutos e ao abrir a tela
    useEffect(() => {
        setRefreshTick(tick => tick + 1) // dispara ao abrir
        const interval = setInterval(() => {
            setRefreshTick(tick => tick + 1)
        }, 300000)
        return () => clearInterval(interval)
    }, [])

    // Atualiza o Snackbar quando props.rows muda ou refreshTick muda
    useEffect(() => {
        setOpen(true)
    }, [props.rows, refreshTick])

    // Atualiza a data/hora sempre que o Snackbar abrir
    useEffect(() => {
        if (open) {
            setRefreshDate(format(Date.now(), 'dd-MM-yyyy - HH:mm:ss'))
        }
    }, [open])

    // Atualiza os dados e o subtitle sempre que refreshTick mudar
    // (coloque todos os cálculos de dados e subtitle dentro do componente, usando refreshTick como dependência)
    const { labels, monthName, month, year } = Calendar()
    const { batery } = BateryData(props.origin, props.menuItens, month, year, props.rows, props.token, refreshTick)
    const { removed } = RemovedData(props.origin, props.menuItens, month, year, props.rows, props.token, refreshTick)
    const { shot } = ShotData(props.origin, props.menuItens, month, year, props.rows, props.token, refreshTick)
    const { alarm } = AlarmData(props.origin, props.menuItens, month, year, props.rows, props.token, refreshTick)
    const { acOut } = ACOutData(props.origin, props.menuItens, month, year, props.rows, props.token, refreshTick)

    // Atualiza o subtitle sempre que refreshTick mudar
    const startDate = format(subDays(new Date(), 29), "dd/MM/yyyy")
    const endDate = format(new Date(), "dd/MM/yyyy")
    const subtitle = `De ${startDate} at\u00e9 ${endDate}`

    const data = {
        labels: shot.labels,
        datasets: []
    }

    const bateryData = {
        labels: batery.labels,
        datasets: []
    }

    const removedData = {
        labels: removed.labels,
        datasets: []
    }

    const shotData = {
        labels: shot.labels,
        datasets: []
    }

    const alarmData = {
        labels: alarm.labels,
        datasets: []
    }

    const generalAlarmData = {
        labels: alarm.labels,
        datasets: []
    }

    const acOutData = {
        labels: acOut.labels,
        datasets: []
    }

    // Paleta moderna
    const palette = [
        "#4F8EF7", // Azul
        "#43D9A3", // Verde
        "#FFB547", // Laranja
        "#F76C5E", // Vermelho
        "#A259F7", // Roxo
        "#6C7A89"  // Cinza moderno para Sem Rede AC
    ];

    // Paleta moderna (cores consistentes com os gráficos individuais)
    const paletteDoughnut = [
        "#4F8EF7", // BATERIA BAIXA (Azul - palette[0])
        "#FFB547", // REMOVIDO (Laranja - palette[2])
        "#F76C5E", // DISPAROS (Vermelho - palette[3])
        "#A259F7", // ALARMES (Roxo - palette[4])
        "#6C7A89"  // SEM REDE AC (Cinza - palette[5])
    ];

    // Exemplo de uso para cada dataset:
    if (batery.datasets !== undefined) {
        batery.datasets.borderColor = palette[0];
        batery.datasets.backgroundColor = "rgba(79, 142, 247, 0.15)";
        bateryData.datasets.push(batery.datasets)
        data.datasets.push(batery.datasets)
    }

    if (removed.datasets !== undefined) {
        removed.datasets.borderColor = palette[2];
        removed.datasets.backgroundColor = "rgba(255, 181, 71, 0.15)";
        removedData.datasets.push(removed.datasets)
        data.datasets.push(removed.datasets)
    }

    if (shot.datasets !== undefined) {
        shot.datasets.borderColor = palette[3];
        shot.datasets.backgroundColor = "rgba(247, 108, 94, 0.15)";
        shotData.datasets.push(shot.datasets)
        data.datasets.push(shot.datasets)
    }

    if (acOut.datasets !== undefined) {
        acOut.datasets.borderColor = palette[5];
        acOut.datasets.backgroundColor = "rgba(108, 122, 137, 0.15)";
        acOutData.datasets.push(acOut.datasets);
        data.datasets.push(acOut.datasets);
    }

    if (alarm.datasets !== undefined) {
        alarm.datasets.borderColor = palette[4];
        alarm.datasets.backgroundColor = "rgba(162, 89, 247, 0.15)";
        alarmData.datasets.push(alarm.datasets)

        if (alarm.general && Array.isArray(alarm.general)) {
            generalAlarmData.datasets = alarm.general.map((ds, idx) => ({
                ...ds,
                borderColor: palette[idx % palette.length],
                backgroundColor: palette[idx % palette.length] + "80",
                pointBackgroundColor: palette[idx % palette.length],
                borderWidth: 3,
                pointRadius: 5,
                tension: 0.4
            }));
        }
    }

    var doughnutData = {}
    const { doughnut } = DoughnutData(
        batery.datasets !== undefined ? batery.datasets.data : 0,
        removed.datasets !== undefined ? removed.datasets.data : 0,
        shot.datasets !== undefined ? shot.datasets.data : 0,
        alarm.datasets !== undefined ? alarm.datasets.data : 0,
        acOut.datasets !== undefined ? acOut.datasets.data : 0
    )
    doughnutData = doughnut

    if (doughnutData && doughnutData.datasets && doughnutData.datasets.length > 0) {
        const dataLength = doughnutData.datasets[0].data.length;
        doughnutData.datasets[0].backgroundColor = paletteDoughnut.slice(0, dataLength);
        doughnutData.datasets[0].borderColor = Array(dataLength).fill("#fff");
        doughnutData.datasets[0].hoverBackgroundColor = paletteDoughnut.slice(0, dataLength).map(c => c + "CC");
    }

    if (alarm.datasets !== undefined && shot.datasets !== undefined && removed.datasets !== undefined && batery.datasets !== undefined && acOut.datasets !== undefined) {

    }

    return (
        <main className="container" style={{ paddingTop: '1.5rem', paddingBottom: '2rem' }}>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={() => setOpen(false)}
                message="Dashboard Atualizado!" />

            <Grid justifyContent='space-between' container spacing={1}>

                <Grid item xs={12} md={12} lg={12}>
                    <Box sx={{ 
                        bgcolor: 'transparent',
                        borderBottom: '1px solid rgba(224, 224, 224, 0.3)',
                        borderRadius: '0',
                        padding: '8px 0',
                        marginBottom: '1rem',
                        boxShadow: 'none',
                        textAlign: 'center',
                        cursor: 'default',
                        pointerEvents: 'none',
                        userSelect: 'none'
                    }}>
                        <Typography 
                            variant="h5" 
                            component="h3" 
                            sx={{ 
                                fontWeight: 400,
                                color: 'text.secondary',
                                letterSpacing: '0.5px',
                                textTransform: 'uppercase',
                                fontSize: '0.95rem'
                            }}
                        >
                            Dashboards
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="body2" color="#8C8C8C">
                        <span style={{ color: "#8C8C8C", fontWeight: "bold", display: "flex", alignItems: "center" }}>
                            <span style={{ marginRight: 6 }}>🕒</span>
                            Dados atualizados em:&nbsp;
                            <span style={{ color: "#FFF" }}>{refreshDate}</span>
                        </span>
                    </Typography>
                    <Typography variant="body2" color="#8C8C8C">
                        <span style={{ color: "#8C8C8C", fontWeight: "bold", display: "flex", alignItems: "center" }}>
                            <span style={{ marginRight: 6 }}>📅</span>
                            Exibindo dados dos &uacute;ltimos 30 dias
                        </span>
                    </Typography>
                </Grid>
            </Grid>

            <br />

            <Grid sx={{ marginBottom: '1rem' }} container spacing={0}>
                <Grid item xs={12} md={12} lg={12}>
                    <div className="info-box info-box--curved info-box--full">
                        <div className="info-box__header">
                            <h4 className="info-box__title">Eventos</h4>
                            <span className="info-box__subtitle">{subtitle}</span>
                        </div>
                        <div className="info-box__body" style={{ width: "100%", padding: "0 16px" }}>
                            <LineDashboard darkMode={props.darkMode} data={data} token={props.token} />
                        </div>
                        <div className="info-box__footer">
                            {/* Coloque aqui informações adicionais, se quiser */}
                        </div>
                    </div>
                </Grid>
            </Grid>

            <Grid container sx={{ marginBottom: '1rem' }} spacing={2}>

                <Grid item xs={12} md={6} lg={6}>
                    {/*<Card>
                        <CardHeader
                            title={'Acionamentos'}
                            subheader={monthName}
                        />
                        <CardContent>
                            <LineDashboard darkMode={props.darkMode} data={shotData} token={props.token} />
                        </CardContent>
                    </Card>*/}
                    <div className="info-box info-box--curved info-box--full">
                        <div className="info-box__header">
                            <h4 className="info-box__title">Acionamentos</h4>
                            <span className="info-box__subtitle">{subtitle}</span>
                        </div>
                        <div className="info-box__body" style={{ width: "100%", padding: "0 16px" }}>
                            <LineDashboard darkMode={props.darkMode} data={shotData} token={props.token} />
                        </div>
                        <div className="info-box__footer">
                            {/* Coloque aqui informações adicionais, se quiser */}
                        </div>
                    </div>
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                    {/*<Card>
                        <CardHeader
                            title={'Bateria Baixa'}
                            subheader={monthName}
                        />
                        <CardContent>
                            <LineDashboard darkMode={props.darkMode} data={bateryData} token={props.token} />
                        </CardContent>
                    </Card>*/}
                    <div className="info-box info-box--curved info-box--full">
                        <div className="info-box__header">
                            <h4 className="info-box__title">Bateria Baixa</h4>
                            <span className="info-box__subtitle">{subtitle}</span>
                        </div>
                        <div className="info-box__body" style={{ width: "100%", padding: "0 16px" }}>
                            <LineDashboard darkMode={props.darkMode} data={bateryData} token={props.token} />
                        </div>
                        <div className="info-box__footer">
                            {/* Coloque aqui informações adicionais, se quiser */}
                        </div>
                    </div>
                </Grid>
            </Grid>

            <Grid sx={{ marginBottom: '1rem' }} container spacing={2}>

                <Grid item xs={12} md={6} lg={6}>
                    {/*<Card>
                        <CardHeader
                            title={'Comandos de Alarmes'}
                            subheader={monthName}
                        />
                        <CardContent>
                            <LineDashboard darkMode={props.darkMode} data={generalAlarmData} token={props.token} />
                        </CardContent>
                    </Card>*/}
                    <div className="info-box info-box--curved info-box--full">
                        <div className="info-box__header">
                            <h4 className="info-box__title">Comandos de Alarme</h4>
                            <span className="info-box__subtitle">{subtitle}</span>
                        </div>
                        <div className="info-box__body" style={{ width: "100%", padding: "0 16px" }}>
                            <LineDashboard darkMode={props.darkMode} data={generalAlarmData} token={props.token} />
                        </div>
                        <div className="info-box__footer">
                            {/* Coloque aqui informações adicionais, se quiser */}
                        </div>
                    </div>
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                    {/*<Card>
                        <CardHeader
                            title={'Removido'}
                            subheader={monthName}
                        />
                        <CardContent>
                            <LineDashboard darkMode={props.darkMode} data={removedData} token={props.token} />
                        </CardContent>
                    </Card>*/}
                    <div className="info-box info-box--curved info-box--full">
                        <div className="info-box__header">
                            <h4 className="info-box__title">Equip. Removido</h4>
                            <span className="info-box__subtitle">{subtitle}</span>
                        </div>
                        <div className="info-box__body" style={{ width: "100%", padding: "0 16px" }}>
                            <LineDashboard darkMode={props.darkMode} data={removedData} token={props.token} />
                        </div>
                        <div className="info-box__footer">
                            {/* Coloque aqui informações adicionais, se quiser */}
                        </div>
                    </div>
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                    {/*<Card>
                        <CardHeader
                            title={'Resumo'}
                            subheader={monthName}
                        />
                        <CardContent>
                            <DoughnutDashboard data={doughnutData} token={props.token} />
                        </CardContent>
                    </Card>*/}
                    <div className="info-box info-box--curved info-box--full">
                        <div className="info-box__header">
                            <h4 className="info-box__title">Resumo</h4>
                            <span className="info-box__subtitle">{subtitle}</span>
                        </div>
                        <div className="info-box__body" style={{ width: "100%", padding: "0 16px" }}>
                            <DoughnutDasboard data={doughnutData} token={props.token} />
                        </div>
                        <div className="info-box__footer">
                            {/* Coloque aqui informações adicionais, se quiser */}
                        </div>
                    </div>

                </Grid>
            </Grid>
        </main>
    )
}